import { combineEpics } from 'redux-observable';
import { createAssetEpic } from './create-asset';
import { replaceAssetEpic } from './replace-asset';
import { startUploadEpic } from './start-upload';
import { uploadProgressEpic } from './upload-progress';
import { finishUploadEpic } from './finish-upload';
import { clearAssetsEpic } from './clear-assets';
import { cancelUploadEpic } from './cancel-upload';
import { getAssetStatusEpic } from './get-status';
import { getStatusAfterGetTrackEpic } from './get-status-after-get-track';
import { getStatusAfterCreateTrackEpic } from './get-status-after-create-track';
import { retryGetStatusEpic } from './retry-get-status';
import { notifyInvalidAssetsEpic } from './notify-invalid-assets';
import { validateAssetExists } from './validate-asset-exists';
import { getStatusAfterVideoEpic } from './get-status-after-video';
import { finishReplaceUploadEpic } from './finish-replace-upload';

const assetsEpic = combineEpics(
  createAssetEpic,
  startUploadEpic,
  uploadProgressEpic,
  finishUploadEpic,
  clearAssetsEpic,
  cancelUploadEpic,
  getAssetStatusEpic,
  getStatusAfterGetTrackEpic,
  getStatusAfterCreateTrackEpic,
  getStatusAfterVideoEpic,
  retryGetStatusEpic,
  notifyInvalidAssetsEpic,
  validateAssetExists,
  replaceAssetEpic,
  finishReplaceUploadEpic
);

export default assetsEpic;
